import { SubpageLayout2018 } from '../subpageLayout';

export default function Sponsors2018Zh() {
  return (
    <SubpageLayout2018 lang="zh" title="贊助" page="sponsors">
      <div className="sponsors_para_introduction para_introduction">
        <h1>贊助</h1>
        <div className="center_introduction">
          <p className="p1">
            「香港智慧城市峰會暨智慧城市大獎2018」的贊助機構於創新科技界的領先企業與人才之中尊享獨有的寶貴推廣機會，以建立和提升品牌形象。
            <br />
            <br />
            通過贊助「香港智慧城市峰會暨智慧城市大獎2018」，您的公司將注入卓越與創新元素，提升公司形象，更可將品牌定位為行業領袖。
            <br />
            <br />
            贊助機構亦將會於頒獎典禮當日向得獎者頒發獎座，能從業界領袖手上接過獎項，絕對是得獎企業的榮幸。
            <br />
            <br />
            成為「香港智慧城市峰會暨智慧城市大獎2018」的贊助機構，廣泛的推廣及公關活動可吸引大眾對贊助機構的興趣，推廣您的公司成為行業的領導。
          </p>
        </div>
        <div className="public_exposure_container">
          <div className="public_container">
            <div className="public_leading">
              <p className="p1">贊助機構將可藉著連串「香港智慧城市峰會暨智慧城市大獎2018」的商業活動，帶動更多商機:</p>
            </div>
            <div className="public_text">
              <p>• 大眾傳媒 <br />• 印刷品及直接郵遞 <br />• 社交媒體 <br />• 戶外廣告等</p>
            </div>
          </div>
          <div className="exposure_container">
            <div className="exposure_leading">
              <p className="p1">贊助機構的品牌將面向下列目標群：</p>
            </div>
            <div className="exposure_text">
              <p>• 領先企業、行業翹楚 <br />• 業內人士、相關專業組織 <br />• 大眾將透過大量媒體曝光認識贊助機構及其品牌</p>
            </div>
          </div>
        </div>
        <div className="organiser sponsor">
          <div className="sponsor">
            <a href="https://www.clp.com.hk/en" target="_blank" rel="noreferrer"><img src="/2018/images/logo/clp.png" alt="" /></a>
            <a href="https://www2.deloitte.com/cn/en.html" target="_blank" rel="noreferrer"><img src="/2018/images/logo/deloitte.png" alt="" /></a>
            <a href="http://www.ey.com/home" target="_blank" rel="noreferrer"><img src="/2018/images/logo/ey.png" alt="" /></a>
            <a href="https://home.kpmg.com/cn/en/home.html" target="_blank" rel="noreferrer"><img src="/2018/images/logo/kpmg.png" alt="" /></a>
          </div>
        </div>
      </div>
    </SubpageLayout2018>
  );
}

